import { YardViewAppointmentBanner } from './YardViewAppointmentBanner';

interface YardViewAppointmentConfirmationProps {
  apptConfirmationNumber: string;
  tmsUpdateSucceeded: boolean;
  apptConfirmationUrl: string;
  tmsUpdatePending?: boolean;
}

export function YardViewAppointmentConfirmation({
  apptConfirmationNumber,
  tmsUpdateSucceeded,
  apptConfirmationUrl,
  tmsUpdatePending = false,
}: YardViewAppointmentConfirmationProps) {
  return (
    <YardViewAppointmentBanner
      variant='success'
      confirmationNumber={apptConfirmationNumber}
      appointmentUrl={apptConfirmationUrl}
      tmsUpdateSucceeded={tmsUpdateSucceeded}
      tmsUpdatePending={tmsUpdatePending}
    />
  );
}
